export enum ENotificationType {
  SALES = 'new_sale',
  REFUND = 'refund_request',
  REPORT = 'report_ready',
  COMISSION = 'new_commission',
  REPORT_NO_DATA = 'report_ready_without_data',
  APPROVED_PRODUCT = 'approved_product',
  DISAPPROVED_PRODUCT = 'disapproved_product',
  BANKSLIP_GENERATED = 'bankslip_generated',
  NEW_CHARGEBACK = 'new_chargeback',
  HIGH_CHARGEBACK_RATE = 'high_chargeback_rate',
  RECURRING_DATE_CHANGE = 'recurring_date_change',
}

export interface INotification<T = any> {
  id: string;
  userId: number;
  title: string;
  message: string;
  payload?: T;
  type: ENotificationType;
  needAction?: boolean;
  readed: boolean;
  visible: boolean;
  updatedAt: Date;
  createdAt: Date;
}

export interface IDueDate {
  id: string;
  dueDate: string;
}
export interface IGroupedNotification {
  userId: number;
  type: ENotificationType;
  needAction: boolean;
  quantity: number;
  dueDates?: IDueDate[];
}

export interface IReportReady {
  nome_produtor: string; // Nome do produtor;
  url_download: string; // Url para download do arquivo do relatório em excel ou csv,
  nome_relatorio: string; // Nome do relatório que foi solicitado,
  status: boolean; // Status booleano de sucesso ou erro
}

export interface IRefundRequest {
  refundId: string; // Id da solicitação de reembolso,
  requestStatus: string; // Id do status da solicitação de reembolso ,
  invoiceId: string; // Id da fatura,
  dueDate: string; // Data limite para reposta do produtor
}

export interface INewSale {
  fatCod: string; // Id da fatura
}

export interface INewCommission {
  fatCod: string; // Id da fatura
}

export interface IReportReadyWithoutData {
  nome_produtor: string; // Nome do produtor
  nome_relatorio: string; // Nome do relatório que foi solicitado
  status: boolean; // Status booleano de sucesso ou erro
}

export interface IApprovedProduct {
  nome: string; // Nome do produtor
  conteudo: string; // Nome do conteudo
}

export interface IDisapprovedProduct {
  nome: string; // Nome do produtor
  conteudo: string; // Nome do conteudo
  motivo: string; // Motivo da reprovação
}
